import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.user.pending_voucher,
    props.user.deposit_bonus,
    (voucher, deposit_bonus) => {
        return {
            voucher,
            deposit_bonus
        }
    }
)